var throttle = require('lodash.throttle');

global.scrollspy = (function ($) {
	var $sections = $('.js-scrollspy-section');
	var $links = $('.js-scrollspy-link');
	var $menu = $('.sidebar-menu');
	var allLevelsExpanded = document.querySelector('.report-page--expanded');
	var smallDesktopUp = window.innerWidth >=1140;
	var sections;
	var previousSectionId ='';
	var offset = $(window).height() * 0.3;

	if ($sections.length === 0 || $links.length === 0) {
		return;
	}

	function isVisible(element, container)
	{
		var containerHeight = container.height();
		var elementTop = $(element).offset().top - container.offset().top;
		var elementBottom = elementTop + $(element).height();
		var isVisible = (elementTop >= 0 && elementBottom <= containerHeight);
		return isVisible;
	}

	function updateSections() {
		$sections = $('.js-scrollspy-section');

		sections = $sections.map(function (i, el) {
			var $el = $(el);
			return {
				id: $el.data('id'),
				title: $el.data('title'),
				topOffset: $el.offset().top
			};
		}).toArray();
	}

	var updateUrl = function (currentSection) {
		document.title = currentSection.title;
		history.pushState(null, currentSection.title, currentSection.id);
		window.tracking.trackPageView(window.location.pathname, currentSection.title);
	};

	var expandMenu = function (node) {
		if (node.data('level') < 3 || allLevelsExpanded) {
			node.siblings('.toggle-menuitems-wrapper').find('.js-open-sub-menuitems').click();
		}
		node.closest('.js-sub-menuitems').siblings('.js-link-wrapper').find('.js-open-sub-menuitems').click();
	};

	var minimizePreviousSubmenu = function () {
		var closeButtons = document.querySelectorAll('.sidebar-menu .sub-menu__item.expanded .js-close-sub-menuitems');
		for ( var i = 0; i < closeButtons.length; i++) {
			closeButtons[i].click();
		}
	};

	var setCurrent = function () {
		var scrollTop = $(window).scrollTop();

		var currentSection = sections.reduce(function (closestSection, section) {
			var distanceFromTop = section.topOffset - scrollTop - offset;
			var hasScrolledPastSectionStart = distanceFromTop <= 0;

			if (closestSection === null || (hasScrolledPastSectionStart &&
				distanceFromTop > closestSection.distanceFromTop)) {
				return {
					id: section.id,
					title: section.title,
					distanceFromTop: distanceFromTop
				};
			}

			return closestSection;
		}, null);

		/*jshint maxcomplexity:false */
		$links.each(function (i, link) {
			var $link = $(link);
			var previousLevelWasDeeper = previousSectionId.split('/').length > currentSection.id.split('/').length ;

			$link.removeClass('js-scrollspy-link--current link--current');
			$link.removeAttr('aria-current');
			if ($link.hasClass('js-scrollspy-expand')) {
				$link.closest('.js-menu-item-expander').removeClass('selected');
			}

			if ($link.data('id') === currentSection.id || link.hash === '#' + currentSection.id) {
				$link.addClass('js-scrollspy-link--current link--current');
				$link.addClass('open');
				$link.attr('aria-current', 'true');

				if (currentSection.id !== previousSectionId) {
					if (previousLevelWasDeeper) {
						minimizePreviousSubmenu();
					}

					if ($link.hasClass('js-scrollspy-expand')) {
						expandMenu($link);
					}
				}

				if (!isVisible($link, $menu) && smallDesktopUp) {
					link.scrollIntoView({block: 'center'});
				}
			}
		});

		if (currentSection.id !== previousSectionId && currentSection.title !== undefined) {
			updateUrl(currentSection);
			previousSectionId = currentSection.id;
		}

	};

	var updateOnScroll = function () {
		if ($('#sidebar-content').hasClass('report-mobile-menu--is-open')) {
			return;
		} else {
			updateSections();
			setCurrent();
		}
	};

	$(window).on('scroll', throttle(updateOnScroll, 250, { trailing: true, leading: true }));

	return {
		updateSections: updateSections
	};
})(jQuery);
